
import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M11.9998 1.3335H3.99984C3.26346 1.3335 2.6665 1.93045 2.6665 2.66683V13.3335C2.6665 14.0699 3.26346 14.6668 3.99984 14.6668H11.9998C12.7362 14.6668 13.3332 14.0699 13.3332 13.3335V2.66683C13.3332 1.93045 12.7362 1.3335 11.9998 1.3335Z"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.6668 8H5.3335" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.6668 10.6665H5.3335" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.00016 5.3335H6.66683H5.3335" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);


export default Icon
